export const GET_VITALS = "api/v1/doctor/get-vitals";
export const ADD_EDIT_VITALS = "api/v1/doctor/add-edit-vitals";
